import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage
} from '@/components/ui/breadcrumb';
import { generateBreadcrumbs } from '@/utils/filterUtils';

interface SequenceBreadcrumbsProps {
  title?: string;
  software?: string;
  holiday?: string;
  genre?: string;
  artist?: string;
  className?: string;
}

const SequenceBreadcrumbs: React.FC<SequenceBreadcrumbsProps> = ({ 
  title, 
  software, 
  holiday, 
  genre, 
  artist,
  className 
}) => {
  // Generate breadcrumb navigation with proper URLs
  const breadcrumbs = generateBreadcrumbs(software, holiday, title);

  // Add genre or artist if present
  const enhancedBreadcrumbs = [...breadcrumbs];
  
  // Remove the title breadcrumb temporarily to insert genre/artist
  const titleBreadcrumb = title ? enhancedBreadcrumbs.pop() : null;
  
  if (genre && !software && !holiday) {
    enhancedBreadcrumbs.push({
      label: genre,
      href: `/sequences/genre/${genre.toLowerCase().replace(/\s+/g, '-')}`,
      isActive: !title
    });
  }
  
  if (artist && !software && !holiday && !genre) {
    enhancedBreadcrumbs.push({
      label: artist,
      href: `/sequences/artist/${artist.toLowerCase().replace(/\s+/g, '-')}`,
      isActive: !title
    });
  }
  
  // Add title back if it exists
  if (titleBreadcrumb) {
    enhancedBreadcrumbs.push(titleBreadcrumb);
  }

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {enhancedBreadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={index}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {breadcrumb.isActive || !breadcrumb.href ? (
                <BreadcrumbPage>{breadcrumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link 
                    to={breadcrumb.href}
                    className="hover:text-foreground transition-colors"
                  >
                    {breadcrumb.label}
                  </Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default SequenceBreadcrumbs;
